/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author Stefan Prosch [hello@stefanprosch.com]
 * contactForm
 */

const contactForm = {
    cfg:  {
        name: 'contactForm',
        form: document.querySelector('#contact-form'),
        formWrapper: document.querySelector('.o-contactForm__wrapper'),
    },

    init() {
        /* eslint-disable */
        /* window.recaptcha_success = (response) => {
            // eslint-disable-next-line
            console.log('Recatpcha Success');
            this.cfg.formWrapper.classList.remove('is-hidden');
            const el = document.createElement('input');
            // eslint-disable-next-line
            const elString = `<input type='hidden' name='action' value='contact-form/send'>`;
            el.innerHTML =  elString;
            // eslint-disable-next-line
            this.cfg.form.appendChild(el.firstChild);
        };
        window.recaptcha_failure = () => {
            // eslint-disable-next-line
            alert('We appologize but Google has marked your activity as suspicious. Please contact us through phone or email.');
        };
        // Called if there is a successful response
        window.recaptcha_callback = (response) => {
            // eslint-disable-next-line
            console.log(response);
        }; */
        /* eslint-enable */
        window.addEventListener('load', () => {
            this.cfg.formWrapper.classList.remove('is-hidden');
            const el = document.createElement('input');
            // eslint-disable-next-line
            const elString = `<input type='hidden' name='action' value='contact-form/send'>`;
            el.innerHTML =  elString;
            // eslint-disable-next-line
            this.cfg.form.appendChild(el.firstChild);
        });
    }
};

export default contactForm;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/contactForm/_script.js